import angular from 'angular';

angular.module('vrm.core').controller('LogoutController', LogoutController);

/**
 * @constructor handle logout page
 * @ngInject
 */
function LogoutController(LoginService, $state, $scope, localStorageService, ApiService) {
    const promise = ApiService.call2('/auth/logout', null, {skipResultChecks: true});
    promise.finally(function () {
        localStorageService.remove("token");
        $scope.$emit('logout');

        // Restore the admin token if present in local storage otherwise go to login
        const adminToken = localStorageService.get('adminToken');
        if (adminToken) {
            localStorageService.set("token", adminToken);
            localStorageService.remove('adminToken');
            $scope.$emit('login');
            $state.go('base.admin.users', null, {location: 'replace'});
        } else {
            $state.go('login', null, {location: 'replace'});
        }
    });
}
